import {
  getFindVenueOverviewVersionQueryKey,
  useUpdateVenueOverviewVersion,
} from '@api';
import { useInvalidateQuery, useNotification } from '@common';
import { AxiosError } from 'axios';
import { SuitesFormDataType } from '../useVenueSuitesFormSchema';

const TRANS_PATH = 'NOTIFICATIONS.UPDATE_VENUE_SUITES';

type UseUpdateVenueSuitesReturnType = {
  updateVenueSuites: (data: SuitesFormDataType) => Promise<void>;
};

type UseUpdateVenueSuitesPropsType = {
  venueId: string;
  overviewVersion: string;
  onClose: () => void;
};

export const useUpdateVenueSuites = ({
  venueId,
  overviewVersion,
  onClose,
}: UseUpdateVenueSuitesPropsType): UseUpdateVenueSuitesReturnType => {
  const { mutateAsync } = useUpdateVenueOverviewVersion();
  const { showSuccess, showError } = useNotification();

  const { invalidateQuery } = useInvalidateQuery(
    getFindVenueOverviewVersionQueryKey(venueId, overviewVersion)
  );

  const onSuccess = (): void => {
    showSuccess({
      title: `${TRANS_PATH}.SUCCESS.TITLE`,
      message: `${TRANS_PATH}.SUCCESS.MESSAGE`,
    });
    invalidateQuery();
    onClose();
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_PATH}.ERROR.TITLE`,
      message: `${TRANS_PATH}.ERROR.MESSAGE`,
      error,
    });
  };

  const updateVenueSuites = async (data: SuitesFormDataType): Promise<void> => {
    await mutateAsync(
      {
        venueId,
        overviewVersion,
        data: { suites: data },
      },
      {
        onSuccess,
        onError,
      }
    );
  };

  return { updateVenueSuites };
};
